import React from 'react';

const DressRulesComponent: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 via-blue-50 to-indigo-100">
      <div className="w-full mx-auto p-8">
        {/* Header Section */}
        <div className="text-center mb-12">
          <div className="inline-block">
            <h1 className="text-5xl font-bold bg-gradient-to-r from-purple-600 via-blue-600 to-indigo-600 bg-clip-text text-transparent mb-4">
              School Rules
            </h1>
            <div className="w-full h-1 bg-gradient-to-r from-purple-400 via-blue-400 to-indigo-400 rounded-full"></div>
          </div>
          <h2 className="text-3xl font-semibold text-gray-700 mt-6 mb-2">School Uniform Guidelines</h2>
          <p className="text-gray-600 text-lg">Looking sharp, feeling confident! ✨</p>
        </div>

        {/* Main Uniform Section */}
        <div className="grid lg:grid-cols-2 gap-8 mb-12">
          {/* Girls Section */}
          <div className="group hover:scale-105 transition-all duration-300">
            <div className="bg-gradient-to-br from-pink-400 via-rose-400 to-purple-500 p-1 rounded-2xl shadow-2xl">
              <div className="bg-white rounded-xl p-8 h-full">
                <div className="text-center mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-pink-400 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-2xl">👩‍🎓</span>
                  </div>
                  <h3 className="text-2xl font-bold bg-gradient-to-r from-pink-500 to-purple-600 bg-clip-text text-transparent">
                    Girls Uniform
                  </h3>
                </div>
                
                <div className="space-y-6">
                  <div className="bg-gradient-to-r from-pink-50 to-purple-50 rounded-xl p-5 border-l-4 border-pink-400">
                    <h4 className="font-bold text-pink-700 mb-3 text-lg flex items-center">
                      <span className="w-2 h-2 bg-pink-400 rounded-full mr-2"></span>
                      Up to Class V
                    </h4>
                    <div className="grid gap-3">
                      <div className="flex items-start space-x-3">
                        <span className="w-2 h-2 bg-gradient-to-r from-pink-400 to-purple-400 rounded-full mt-2 flex-shrink-0"></span>
                        <div><span className="font-semibold text-gray-700">Shirt:</span> <span className="text-gray-600">Blue with yellow and Red collar with arm band</span></div>
                      </div>
                      <div className="flex items-start space-x-3">
                        <span className="w-2 h-2 bg-gradient-to-r from-pink-400 to-purple-400 rounded-full mt-2 flex-shrink-0"></span>
                        <div><span className="font-semibold text-gray-700">Skirts:</span> <span className="text-gray-600">Navy Blue with Red, Yellow strips</span></div>
                      </div>
                      <div className="flex items-start space-x-3">
                        <span className="w-2 h-2 bg-gradient-to-r from-pink-400 to-purple-400 rounded-full mt-2 flex-shrink-0"></span>
                        <div><span className="font-semibold text-gray-700">Shoes:</span> <span className="text-gray-600">Black leather</span></div>
                      </div>
                      <div className="flex items-start space-x-3">
                        <span className="w-2 h-2 bg-gradient-to-r from-pink-400 to-purple-400 rounded-full mt-2 flex-shrink-0"></span>
                        <div><span className="font-semibold text-gray-700">Socks:</span> <span className="text-gray-600">Navy Blue with two yellow strips</span></div>
                      </div>
                      <div className="flex items-start space-x-3">
                        <span className="w-2 h-2 bg-gradient-to-r from-pink-400 to-purple-400 rounded-full mt-2 flex-shrink-0"></span>
                        <div><span className="font-semibold text-gray-700">Jersey:</span> <span className="text-gray-600">Navy blue with Yellow strips (Half/Full sleeves)</span></div>
                      </div>
                      <div className="flex items-start space-x-3">
                        <span className="w-2 h-2 bg-gradient-to-r from-pink-400 to-purple-400 rounded-full mt-2 flex-shrink-0"></span>
                        <div><span className="font-semibold text-gray-700">Jacket:</span> <span className="text-gray-600">Navy Blue</span> <span className="bg-pink-100 text-pink-700 px-2 py-1 rounded-full text-xs font-medium">Compulsory</span></div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gradient-to-r from-purple-50 to-indigo-50 rounded-xl p-5 border-l-4 border-purple-400">
                    <h4 className="font-bold text-purple-700 mb-3 text-lg flex items-center">
                      <span className="w-2 h-2 bg-purple-400 rounded-full mr-2"></span>
                      Above Class V
                    </h4>
                    <div className="grid gap-3">
                      <div className="flex items-start space-x-3">
                        <span className="w-2 h-2 bg-gradient-to-r from-purple-400 to-indigo-400 rounded-full mt-2 flex-shrink-0"></span>
                        <div><span className="font-semibold text-gray-700">Kurta:</span> <span className="text-gray-600">Blue with Yellow and Red striped collar and arm band</span></div>
                      </div>
                      <div className="flex items-start space-x-3">
                        <span className="w-2 h-2 bg-gradient-to-r from-purple-400 to-indigo-400 rounded-full mt-2 flex-shrink-0"></span>
                        <div><span className="font-semibold text-gray-700">Salwar:</span> <span className="text-gray-600">Navy Blue</span></div>
                      </div>
                      <div className="flex items-start space-x-3">
                        <span className="w-2 h-2 bg-gradient-to-r from-purple-400 to-indigo-400 rounded-full mt-2 flex-shrink-0"></span>
                        <div><span className="font-semibold text-gray-700">Chunni:</span> <span className="text-gray-600">Navy Blue</span></div>
                      </div>
                      <div className="flex items-start space-x-3">
                        <span className="w-2 h-2 bg-gradient-to-r from-purple-400 to-indigo-400 rounded-full mt-2 flex-shrink-0"></span>
                        <div><span className="font-semibold text-gray-700">Shoes:</span> <span className="text-gray-600">Black Leather</span></div>
                      </div>
                      <div className="flex items-start space-x-3">
                        <span className="w-2 h-2 bg-gradient-to-r from-purple-400 to-indigo-400 rounded-full mt-2 flex-shrink-0"></span>
                        <div><span className="font-semibold text-gray-700">Socks:</span> <span className="text-gray-600">Navy Blue with two yellow strips</span></div>
                      </div>
                      <div className="flex items-start space-x-3">
                        <span className="w-2 h-2 bg-gradient-to-r from-purple-400 to-indigo-400 rounded-full mt-2 flex-shrink-0"></span>
                        <div><span className="font-semibold text-gray-700">Blazer:</span> <span className="text-gray-600">Navy Blue</span> <span className="bg-purple-100 text-purple-700 px-2 py-1 rounded-full text-xs font-medium">Compulsory</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Boys Section */}
          <div className="group hover:scale-105 transition-all duration-300">
            <div className="bg-gradient-to-br from-blue-400 via-cyan-400 to-teal-500 p-1 rounded-2xl shadow-2xl">
              <div className="bg-white rounded-xl p-8 h-full">
                <div className="text-center mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-400 to-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-2xl">👨‍🎓</span>
                  </div>
                  <h3 className="text-2xl font-bold bg-gradient-to-r from-blue-500 to-teal-600 bg-clip-text text-transparent">
                    Boys Uniform
                  </h3>
                </div>
                
                <div className="bg-gradient-to-r from-blue-50 to-teal-50 rounded-xl p-6 border-l-4 border-blue-400">
                  <div className="grid gap-4">
                    <div className="flex items-start space-x-3">
                      <span className="w-2 h-2 bg-gradient-to-r from-blue-400 to-teal-400 rounded-full mt-2 flex-shrink-0"></span>
                      <div><span className="font-semibold text-gray-700">Shirt:</span> <span className="text-gray-600">Blue with Yellow and Red stripped collar with arm band</span></div>
                    </div>
                    <div className="flex items-start space-x-3">
                      <span className="w-2 h-2 bg-gradient-to-r from-blue-400 to-teal-400 rounded-full mt-2 flex-shrink-0"></span>
                      <div><span className="font-semibold text-gray-700">Shorts/Trouser:</span> <span className="text-gray-600">Navy blue</span> <span className="bg-blue-100 text-blue-700 px-2 py-1 rounded-full text-xs font-medium">Shorts compulsory for primary in summer</span></div>
                    </div>
                    <div className="flex items-start space-x-3">
                      <span className="w-2 h-2 bg-gradient-to-r from-blue-400 to-teal-400 rounded-full mt-2 flex-shrink-0"></span>
                      <div><span className="font-semibold text-gray-700">Shoes:</span> <span className="text-gray-600">Black leather</span></div>
                    </div>
                    <div className="flex items-start space-x-3">
                      <span className="w-2 h-2 bg-gradient-to-r from-blue-400 to-teal-400 rounded-full mt-2 flex-shrink-0"></span>
                      <div><span className="font-semibold text-gray-700">Socks:</span> <span className="text-gray-600">Navy blue with two yellow strips</span></div>
                    </div>
                    <div className="flex items-start space-x-3">
                      <span className="w-2 h-2 bg-gradient-to-r from-blue-400 to-teal-400 rounded-full mt-2 flex-shrink-0"></span>
                      <div><span className="font-semibold text-gray-700">Jersey:</span> <span className="text-gray-600">Navy Blue with Yellow strips (Half/Full)</span></div>
                    </div>
                    <div className="flex items-start space-x-3">
                      <span className="w-2 h-2 bg-gradient-to-r from-blue-400 to-teal-400 rounded-full mt-2 flex-shrink-0"></span>
                      <div><span className="font-semibold text-gray-700">Jacket:</span> <span className="text-gray-600">Navy Blue (Nursery to V)</span> <span className="bg-blue-100 text-blue-700 px-2 py-1 rounded-full text-xs font-medium">Compulsory</span></div>
                    </div>
                    <div className="flex items-start space-x-3">
                      <span className="w-2 h-2 bg-gradient-to-r from-blue-400 to-teal-400 rounded-full mt-2 flex-shrink-0"></span>
                      <div><span className="font-semibold text-gray-700">Blazer:</span> <span className="text-gray-600">Navy Blue (VI onwards)</span> <span className="bg-blue-100 text-blue-700 px-2 py-1 rounded-full text-xs font-medium">Compulsory</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* P.T. Uniform Section */}
        <div className="group hover:scale-105 transition-all duration-300">
          <div className="bg-gradient-to-r from-orange-400 via-yellow-400 to-amber-400 p-1 rounded-2xl shadow-2xl">
            <div className="bg-white rounded-xl p-8">
              <div className="text-center mb-8">
                <div className="w-20 h-20 bg-gradient-to-br from-orange-400 to-amber-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-3xl">🏃‍♀️</span>
                </div>
                <h3 className="text-3xl font-bold bg-gradient-to-r from-orange-500 to-amber-600 bg-clip-text text-transparent mb-2">
                  P.T. UNIFORM
                </h3>
                <p className="text-gray-600 font-medium">WEDNESDAY & SATURDAY</p>
              </div>
              
              <div className="grid lg:grid-cols-2 gap-8">
                {/* Summer */}
                <div className="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-xl p-6 border-l-4 border-yellow-400">
                  <h4 className="text-2xl font-bold text-yellow-700 mb-6 flex items-center">
                    <span className="text-2xl mr-3">☀️</span>
                    SUMMER
                  </h4>
                  
                  <div className="space-y-5">
                    <div className="bg-white rounded-lg p-4 shadow-sm border-l-4 border-yellow-300">
                      <h5 className="font-bold text-yellow-600 mb-2 flex items-center">
                        <span className="w-2 h-2 bg-yellow-400 rounded-full mr-2"></span>
                        Girls up to V
                      </h5>
                      <p className="text-gray-600 text-sm leading-relaxed">White Kurta & House Shirt, White Socks and White P.T. Shoes</p>
                    </div>
                    
                    <div className="bg-white rounded-lg p-4 shadow-sm border-l-4 border-orange-300">
                      <h5 className="font-bold text-orange-600 mb-2 flex items-center">
                        <span className="w-2 h-2 bg-orange-400 rounded-full mr-2"></span>
                        Girls VI & Above
                      </h5>
                      <p className="text-gray-600 text-sm leading-relaxed">White Kurta with flaps of particular house colour, white salwar & white chunni, white socks and white P.T. shoes</p>
                    </div>
                    
                    <div className="bg-white rounded-lg p-4 shadow-sm border-l-4 border-amber-300">
                      <h5 className="font-bold text-amber-600 mb-2 flex items-center">
                        <span className="w-2 h-2 bg-amber-400 rounded-full mr-2"></span>
                        Boys Nursery to XII
                      </h5>
                      <p className="text-gray-600 text-sm leading-relaxed">White trouser/shorts, house T-Shirt, P.T. Shoes, White socks</p>
                    </div>
                  </div>
                </div>

                {/* Winter */}
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-6 border-l-4 border-blue-400">
                  <h4 className="text-2xl font-bold text-blue-700 mb-6 flex items-center">
                    <span className="text-2xl mr-3">❄️</span>
                    WINTER
                  </h4>
                  
                  <div className="space-y-5">
                    <div className="bg-white rounded-lg p-4 shadow-sm border-l-4 border-blue-300">
                      <h5 className="font-bold text-blue-600 mb-2 flex items-center">
                        <span className="w-2 h-2 bg-blue-400 rounded-full mr-2"></span>
                        Boys & Girls VI & Above
                      </h5>
                      <p className="text-gray-600 text-sm leading-relaxed">Track suit with house T-Shirt</p>
                    </div>
                    
                    <div className="bg-white rounded-lg p-4 shadow-sm border-l-4 border-indigo-300">
                      <h5 className="font-bold text-indigo-600 mb-2 flex items-center">
                        <span className="w-2 h-2 bg-indigo-400 rounded-full mr-2"></span>
                        Boys & Girls below V
                      </h5>
                      <p className="text-gray-600 text-sm leading-relaxed">Same as for summer with school jersey and Jackets</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-12">
          <div className="inline-block bg-gradient-to-r from-purple-400 to-indigo-400 rounded-full px-8 py-3">
            <p className="text-white font-semibold">Dress smart, learn smarter! 🎓✨</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DressRulesComponent;